<template>
  <tabbed-editor-header-card :title="title" class="purchase-order-header">
    <p>{{ plannedDeliveryAt | dateFilter }}</p>
  </tabbed-editor-header-card>
</template>

<script>
import TabbedEditorHeaderCard from '@/components/crud/TabbedEditorHeaderCard';

export default {
  components: {
    TabbedEditorHeaderCard
  },
  filters: {
    dateFilter(dateTime) {
      if (dateTime) {
        const dateObj = new Date(dateTime);
        return `${dateObj.toLocaleDateString()}`;
      }
    }
  },
  props: {
    fabricOrder: Object
  },
  computed: {
    title() {
      let title = '';
      if (this.fabricOrder && this.fabricOrder.domainID) {
        const domain = this.$store.getters['domain/getLoadedItemByID'](this.fabricOrder.domainID);
        title = domain && domain.name;
      }
      return title;
    },
    plannedDeliveryAt() {
      return this.fabricOrder && this.fabricOrder.plannedDeliveryAt;
    }
  }
};
</script>
